import { render, staticRenderFns } from "./EntityVariableDetailedView.vue?vue&type=template&id=35331212"
import script from "./EntityVariableDetailedView.vue?vue&type=script&lang=js"
export * from "./EntityVariableDetailedView.vue?vue&type=script&lang=js"
import style0 from "./EntityVariableDetailedView.vue?vue&type=style&index=0&id=35331212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports